/**
 * Types for To-Do sort and filter preferences.
 */

export type TodoSortOption =
  | 'manual'
  | 'alpha-asc'
  | 'alpha-desc'
  | 'newest'
  | 'oldest'
  | 'priority-first'
  | 'normal-first';

export type TodoFilterOption = 'all' | 'priority-only' | 'normal-only';

export type TodoPreferences = {
  sort: TodoSortOption;
  filter: TodoFilterOption;
};

export const DEFAULT_TODO_PREFERENCES: TodoPreferences = {
  sort: 'manual',
  filter: 'all',
};
